/**
 * Created by sidchik on 07.10.14.
 */

var mapsbyId = {};
function YandexMapGo(ID, data, nocontrol, defZoom, center, setBounds) {
  var map_container = $("#" + ID);

  var type = map_container.attr('data-type');

  var myMap = new ymaps.Map(
    ID,
    {
      center: center,
      ScrollZoom: false,
      zoom: defZoom,
      controls: ['smallMapDefaultSet']
    }
  );
  myMap.controls.remove('searchControl');
  myMap.behaviors.disable('scrollZoom');

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    myMap.behaviors.disable('drag');
  }

  mapsbyId[ID] = myMap;

  var collection = new ymaps.GeoObjectCollection();


  for (var i = 0; i < data.length; i++) {
    var item = data[i];
    item.coords = [parseFloat(item.coords[0]), parseFloat(item.coords[1])];
    if ((item.coords !== undefined) & (!isNaN(item.coords[0]))) {
      var HintLayout = ymaps.templateLayoutFactory.createClass("<div class='my-hint'>{{ properties.hint|raw }}</div>", {
          getShape: function () {
            var el = this.getElement(),
              result = null;
            if (el) {
              var firstChild = el.firstChild;
              result = new ymaps.shape.Rectangle(
                new ymaps.geometry.pixel.Rectangle([
                  [0, 0],
                  [firstChild.offsetWidth, firstChild.offsetHeight]
                ])
              );
            }
            return result;
          }
        }
      );

      var placeData = {
        hint: item.hint
      };

      if (item.balloon) {
        placeData.balloonContent = item.balloon;
      }

      var myPlacemark = new ymaps.Placemark(item.coords, placeData, {
        preset: item.preset || '',
        zIndex: item.zIndex || null
      });

      if (item.url) {
        myPlacemark.events.add('click', function () {
          window.location = item.url;
        });
      }

      collection.add(myPlacemark);

    }
  }
  myMap.geoObjects.add(collection);
  if (setBounds) {
    myMap.setBounds(myMap.geoObjects.getBounds());
  }
  if (data.length == 1) {
    myMap.setZoom(defZoom);
  }
}